import PropTypes from 'prop-types'

import { withRouterProps } from '../../../utils/wrappers'
import { SVGWrapper } from '../../../components'
import { IpmArrowRight } from '../../../assets/icons'
import { ReactComponent as HeyNicIcon } from '../../../assets/icons/HeyNicIconOnly.svg'
import { HomeCommentCard, HomeCommentText } from './styled'

/*
 * Narrow-viewport entry point: the chatbot's opening comment, shown under the
 * plan. Tapping it opens the standalone chat exactly as the "Hey Nic" side-menu
 * entry does, except that this comment is already sitting there as the first
 * message — handed over in router state and rendered client-side by HeyNic, so
 * it is never persisted or sent to the agent.
 *
 * This replaces the plain Hey Nic bubble on the accumulation Home screen; the
 * spend-down screen still uses that one (HomeHeyNicBubble) until it is
 * redesigned.
 */
const HomeHeyNicComment = ({ comment, suggestions, promptKeys, navigate, location }) => (
  <HomeCommentCard
    type='button'
    onClick={() =>
      navigate('/hey-nic', {
        state: {
          from: location?.pathname ?? '/home',
          leading: comment,
          leadingSuggestions: suggestions,
          promptKeys,
        },
      })
    }
    aria-label={`Hey Nic: ${comment}`}>
    <HeyNicIcon />
    <HomeCommentText>{comment}</HomeCommentText>
    {/* Signals that the card opens the chat rather than just stating something. */}
    <SVGWrapper className='comment-chevron' svg={IpmArrowRight} size='mediumLarge' />
  </HomeCommentCard>
)

HomeHeyNicComment.propTypes = {
  /** The FE-authored opening comment (see homeChatDefaults.homeChatComment). */
  comment: PropTypes.string.isRequired,
  /** Its starter pills, handed to the chat along with the comment. */
  suggestions: PropTypes.arrayOf(PropTypes.string),
  /**
   * Every help-bearing alert that is live, in the order they take the pills —
   * which of them the chat answers itself, and who takes over as each finishes.
   *
   * The queue rather than a flag per exchange: the route cannot recompute
   * alerts, so anything not handed over here is invisible to it forever, and a
   * second way of saying who owns the pills is a second thing to drift.
   */
  promptKeys: PropTypes.arrayOf(PropTypes.string),
}

export default withRouterProps(HomeHeyNicComment)
